<template>
  <div>
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <div class="cart-icon" v-on:click="goCart()">
            <img src="@/assets/img/cart.png" width="25" />
            <span class="cart-count">{{ carts.length }}</span>
          </div>

          <base-button style="font-size: 18px" @click="getBack()" class="btn-link btn-back">
            &lt; Back
          </base-button>
        </div>
      </div>
      <br />
      <br />

      <div class="row">
        <div v-for="(product, index) in products" :key="index" class="custom-col mb-4">
          <div class="card text-center">
            <p class="card-title">{{ product.name }}</p>
            <img style="height: 20%" :src="product.image.fileurl" />

            <!-- <div class="col-lg-12"> -->
            <div class="row justify-content-center align-items-center">
              <button class="btn-decrease" @click="decreaseQuantity(product)">-</button>
              <input type="number" v-model.number="product.quantity" class="quantity-display quantity-input no-stepper"
                @change="onQuantityChange(product)" />
              <button class="btn-increase" @click="increaseQuantity(product)">+</button>
              <p style="color: #A5A5A5; margin-left: 10px">Kg</p>
            </div>
            <br />
            <!-- </div> -->

            <!-- <div class="col-lg-12"> -->
            <div style="width: 100%" class="row justify-content-center align-items-center">
              <div class="col-lg-6 text-right">
                <base-button style="font-size: 11px; width: 100%;
  height: 40px; padding-left: 10px; padding-right: 10px;" :disabled="canadd(product.quantity)" type="primary"
                  v-on:click="addToCart(product.wastetypeid, product.quantity)">
                  Add to cart
                </base-button>
              </div>
              <div class="col-lg-6 text-left">
                <base-button style="font-size: 11px; width: 100%;
  height: 40px; padding-left: 10px; padding-right: 10px;" :disabled="canadd(product.quantity)" type="primary"
                  v-on:click="goBuyNow(product.wastetypeid, product.quantity, product.image.fileurl, product.name)">
                  Request
                </base-button>
                <!-- </div> -->
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div ref="scrolling" v-if="!lastpage" class="scroll-anchor"></div>
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  data() {
    return {
      roleid: 0,
      path: '',
      load: false,
      products: [],
      carts: [],
      cartItemCount: 0,

      page: 0,
      size: 10,
      lastpage: false,
      observer: null,
    };
  },
  methods: {
    canadd(qty) {
      return qty <= 0;
    },
    getCartData() {
      this.load = true;
      this.carts = [];

      this.$http
        .get(":10001/api/v1/shop/carts")
        .then((res) => {
          if (!res.error) {
            let response = res.message.items;

            for (let i = 0; i < response.length; i++) {
              let image = {};
              if (response[i].image != null) {
                image = {
                  // filename: response[i].waste_type.image.meta.filename,
                  fileurl: response[i].waste_type.image.url,
                  fileid: response[i].waste_type.image.image_id,
                }
              }
              let obj = {
                cartid: response[i].cart_id,
                quantity: response[i].quantity,
                name: response[i].waste_type.name,
                description: response[i].waste_type.description,
                corrosive: response[i].waste_type.corrosive,
                hazardous: response[i].waste_type.hazardous,
                image: image,
                inventory: response[i].waste_type.inventory.quantity,
              };
              this.carts.push(obj);
            }

            this.load = false;
          }
        });
    },
    getData() {
      this.load = true;
      // this.products = [];

      this.$http
        .get(":10001/api/v1/shop/public/products?size=" + this.size + "&filters=&page=" + this.page)
        .then((res) => {
          if (!res.error) {
            let response = res.message.items;

            for (let i = 0; i < response.length; i++) {
              let image = {};
              if (response[i].image != null) {
                image = {
                  filename: response[i].image.meta.filename,
                  fileurl: response[i].image.url == null ? 'https://afes-eprf.s3.ap-southeast-1.amazonaws.com/default/No_Image_Available.jpg' : response[i].image.url,
                  fileid: response[i].image.image_id,
                }
              } else {
                image = {
                  filename: 'No image found',
                  fileurl: 'https://afes-eprf.s3.ap-southeast-1.amazonaws.com/default/No_Image_Available.jpg',
                  fileid: 0,
                }
              }
              let obj = {
                wastetypeid: response[i].waste_type_id,
                name: response[i].name,
                description: response[i].description,
                corrosive: response[i].corrosive,
                hazardous: response[i].hazardous,
                image: image,
                inventory: response[i].inventory.quantity,
                quantity: 1,
              };
              this.products.push(obj);
            }

            this.lastpage = res.message.last;
            this.load = false;
          }
        });
    },
    buyNow() {

    },
    addToCart(wastetypeid, quantity) {
      let obj = {
        waste_type_id: wastetypeid,
        quantity: quantity,
        action: 'add',
      };
      console.log(obj);
      this.$http
        .post(
          ":10001/api/v1/shop/carts", obj
        )
        .then((res) => {
          if (!res.error) {
            this.getCartData();
            swal({
              title: `Success!`,
              text: 'Success adding to cart.',
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value) {
                // this.modals.viewproforma = false;
              }
            });
          } else {
          }
        }).catch((err) => {
          swal({
            title: `Error!`,
            text: 'Failed to add into cart.',
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });
    },


    updateCartItemCount() {
      let cart = JSON.parse(localStorage.getItem('cart')) || [];
      this.cartItemCount = cart.length;
    },
    decreaseQuantity(product) {
      if (product.quantity > 1) {
        product.quantity--;
      }
    },
    increaseQuantity(product) {
      product.quantity++;
    },
    onQuantityChange(product) {
      if (product.quantity < 1) {
        product.quantity = 1;
      }
    },
    getBack() {
      this.$router.push('/Vessel/Sales');
    },
    goCart() {
      this.$router.push('/Vessel/Cart');
    },
    goBuyNow(wastetypeid, qty, url, name) {
      sessionStorage.setItem("wastetypeid", wastetypeid);
      sessionStorage.setItem("quantity", qty);
      sessionStorage.setItem("imageurl", url);
      sessionStorage.setItem("itemname", name);
      this.$router.push('/Vessel/RequestItem');
    }
  },
  created() {
    this.getCartData();
    this.getData();

    this.roleid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1])).role_id
    );

    console.log('roleid', this.roleid);

    if (this.roleid == 2) {
      this.path = 'Land';
    } else if (this.roleid == 3) {
      this.path = 'Vessel';
    }
  },
  mounted() {
    this.updateCartItemCount();

    this.observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !this.load && !this.lastpage) {
        this.page += 1;
        this.getData();
      }
    });
    this.observer.observe(this.$refs.scrolling);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  computed: {

  }
};
</script>

<style scoped>
.container {
  padding: 20px;
  position: relative;
}

.cart-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #358CCB;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.cart-icon i {
  font-size: 24px;
  color: white;
}

.cart-count {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 24px;
  height: 24px;
  background-color: #EC1B23;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
}

.card {
  border-radius: 5px;
  background-color: white;
  box-shadow: none;
  flex-direction: column;
  align-items: center;
  padding: 10px 0px 10px 0px;
  width: 100%;
  height: 380px;
}

.card img {
  max-width: 90%;
  min-height: 170px;
  object-fit: contain;
}

.card-title {
  font-size: 13px;
  color: #000;
  text-align: center;
  margin-bottom: 10px;
  margin-left: 20px;
  margin-right: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 4.5em;
  line-height: 1.5em;
}

.card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.quantity-control {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 30px;
  overflow: hidden;
  border: 1px solid #C5C5C5;
  width: 50%;
  margin: 0 auto 10px auto;
  /* Spacing below the quantity control */
}

.quantity-control button {
  border: none;
  background-color: transparent;
  font-size: 20px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #333;
}

.quantity-display {
  border: none;
  border: 1px solid #C5C5C5;
  text-align: center;
  width: 40%;
  font-size: 16px;
  color: #007bff;
  background-color: #fff;
  margin: 0;
  padding: 0;
  height: 25px;
  line-height: 30px;
}

.quantity-input:focus {
  outline: none;
}

.button-group {
  justify-content: center;
  /* gap: 10px; */
  /* margin-top: auto; */
}

.btn-back {
  color: #358CCB;
  background: transparent;
}

.btn-back:hover {
  color: #358CCB !important;
  text-decoration: underline;
}

.custom-col {
  width: calc(100% / 5);
  padding: 10px;
}

@media (max-width: 1200px) {
  .custom-col {
    width: calc(100% / 4);
  }
}

@media (max-width: 992px) {
  .custom-col {
    width: calc(100% / 3);
  }
}

@media (max-width: 768px) {
  .custom-col {
    width: calc(100% / 2);
  }
}

@media (max-width: 576px) {
  .custom-col {
    width: 100%;
  }
}

.no-stepper::-webkit-outer-spin-button,
.no-stepper::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-stepper[type=number] {
  -moz-appearance: textfield;
}

.btn-decrease {
  background-color: white;
  border: none;
  height: 25px;
  width: 30px;
  border-top: 1px solid #C5C5C5;
  border-bottom: 1px solid #C5C5C5;
  border-left: 1px solid #C5C5C5;
  border-radius: 21px 0px 0px 21px;
}

.btn-increase {
  background-color: white;
  border: none;
  height: 25px;
  width: 30px;
  border-top: 1px solid #C5C5C5;
  border-bottom: 1px solid #C5C5C5;
  border-right: 1px solid #C5C5C5;
  border-radius: 0px 21px 21px 0px;
}

.scroll-anchor {
  height: 1px;
}
</style>
